import React from 'react'
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
} from '@mui/material'
import { useAppState } from 'Context/AppContext/AppContext'
import { GoalGroupGranteeInfo } from 'Generated/graphql-types'
import { toTitleCase } from 'Utils/formatters'
import { PersonOff } from '@mui/icons-material'
import { HeaderContainer, SectionContainer } from './FunderGoalSections.styled'
import { SuperLoading } from '../../../../SharedComponents/Loading/SuperLoading'
import { GoalSectionEmptyState } from '../EmptyStates/GoalSectionEmptyState'
import { EmptyStateHeaderContainer } from '../EmptyStates/FunderGoalsEmptyState.styled'

type GranteesSectionProps = {
  goalGroupGranteeInfo: GoalGroupGranteeInfo[]
  goalGroupTargetDescription: string
  loading: boolean
}

export const GranteesSection = ({
  goalGroupGranteeInfo,
  goalGroupTargetDescription,
  loading,
}: GranteesSectionProps) => {
  const { funderOrgConfig } = useAppState()
  if (loading) return <SuperLoading />
  if (!loading && !goalGroupGranteeInfo.length)
    return (
      <EmptyStateHeaderContainer>
        <HeaderContainer>Progress Chart</HeaderContainer>
        <GoalSectionEmptyState
          icon={<PersonOff />}
          headerText='No Grantees Assigned'
          subheaderText='Grantees will appear here once the goal is set in collaboration with your Customer Success Manager (CSM).'
        />
      </EmptyStateHeaderContainer>
    )

  const granteeInformationRows = goalGroupGranteeInfo.map((grantee) => {
    const granteeName =
      funderOrgConfig.sponsoredNonprofits[grantee.nonprofitOrgId].name

    return (
      <TableRow key={grantee.nonprofitOrgId}>
        <TableCell>{granteeName}</TableCell>
        <TableCell>{grantee.goalName}</TableCell>
        <TableCell>
          {grantee.goalProgress > 0
            ? `${grantee.goalProgress} ${toTitleCase(
                goalGroupTargetDescription
              )}`
            : 'No data'}
        </TableCell>
        <TableCell>
          {grantee.totalTasks
            ? `${grantee.completedTasks}/${grantee.totalTasks}`
            : 'N/A'}
        </TableCell>
      </TableRow>
    )
  })

  return (
    <SectionContainer>
      <HeaderContainer>
        Grantees ({goalGroupGranteeInfo.length})
      </HeaderContainer>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel>Grantee Name</TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel>Grantee&apos;s Goal Name</TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel>Progress Chart</TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel>Task Completion</TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{granteeInformationRows}</TableBody>
        </Table>
      </Paper>
    </SectionContainer>
  )
}
